import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { VulnerabilityManagementProvider } from '../../contexts/VulnerabilityManagementContext';
import VulnerabilityDashboard from './VulnerabilityDashboard';
import NewAnalysis from './NewAnalysis';
import AnalysisLayout from './AnalysisLayout';
import Report from './Report';
import VulnerabilityDetail from './VulnerabilityDetail';

/**
 * Wraps the inner Routes in VulnerabilityManagementProvider so all
 * vuln-mgmt sub-routes share the provider's state.
 *
 * The `analysis/:uuid` route is a **layout route** with two
 * children: the index renders the components/vulnerabilities
 * tables (<Report />) and `vulnerability/:vulnId` renders the
 * per-vuln detail body. The shared chrome (PageLayout +
 * sub-header with scan name + version switcher + severity circles
 * + Components/Vulnerabilities tab strip) lives in AnalysisLayout
 * and stays mounted across the two child routes, so transitioning
 * from the vulns table to the detail body doesn't re-render the
 * chrome.
 */
export const vulnerabilityManagementRoutes = (
  <Route
    path="vulnerability-management/*"
    element={
      <VulnerabilityManagementProvider>
        <Routes>
          <Route index element={<VulnerabilityDashboard />} />
          <Route path="projects/new" element={<NewAnalysis />} />
          <Route path="projects/:projectUuid/scans/new" element={<NewAnalysis />} />
          <Route path="analysis/:uuid" element={<AnalysisLayout />}>
            <Route index element={<Report />} />
            <Route path="vulnerability/:vulnId" element={<VulnerabilityDetail />} />
          </Route>
        </Routes>
      </VulnerabilityManagementProvider>
    }
  />
);
